import React from "react";

const howItWorksContent = [
  {
    title: "Submit a Tender",
    sideIcon: "fas fa-file-signature",
    visualIcon: "fas fa-clipboard-check",
    visualText: "Register and Remain Active",
    steps: [
      {
        label: "Find the Option Above:",
        text: " Marked for you on the home page.",
      },
      {
        label: "Click Sign Up:",
        text: " To create your account.",
      },
      {
        label: "Fill In Your Details:",
        text: " Enter your basic information. i.e. Name, email, phone number etc.",
      },
      {
        label: "Log In & Get Started:",
        text: " Use your registered email and password to start using your account.",
      },
    ],
  },
  {
    title: "Become an Affiliate",
    sideIcon: "fas fa-handshake",
    visualIcon: "fas fa-users",
    visualText: "Thrive Through Community",
    steps: [
      {
        label: "Find the Option Above:",
        text: " Marked for you on the home page.",
      },
      {
        label: "Click Sign Up:",
        text: " To create your account.",
      },
      {
        label: "Fill In Your Details:",
        text: " Enter your basic information. i.e. Name, email, phone number etc.",
      },
      {
        label: "Verify Your Account:",
        text: " Upload the required documents.",
      },
      {
        label: "Log In & Get Started:",
        text: " Use your registered email and password to start using your account.",
      },
      {
        label: "Stay Updated:",
        text: " Check in regularly for updates.",
      },
    ],
  },
  {
    title: "Login to Your Selected System",
    sideIcon: "fas fa-lock",
    visualIcon: "fas fa-sign-in-alt",
    visualText: "Systems Login",
    reverse: true,
    steps: [
      {
        label: "Find Your Preferred Option:",
        text: " On the home page.",
      },
      {
        label: "Enter Credentials:",
        text: " Input your registered email and password.",
      },
      {
        label: "Click Login:",
        text: " To Access Your Account.",
      },
      {
        label: "Get Started:",
        text: " Begin making the most of the systems you’ve chosen.",
      },
    ],
  },
];

const HowItWorksStepCard = ({
  title,
  sideIcon,
  visualIcon,
  visualText,
  steps,
  reverse = false,
}) => {
  return (
    <div
      className={`how-works-step-card ${
        reverse ? "how-works-step-card-reverse" : ""
      }`}
    >
      {!reverse && (
        <div className="how-works-side-rail">
          <i className={sideIcon} />
        </div>
      )}

      {reverse && (
        <div className="how-works-visual">
          <div className="how-works-visual-card">
            <i className={visualIcon} />
            <span>{visualText}</span>
          </div>
        </div>
      )}

      <div className="how-works-content">
        <h3 className="how-works-card-title">{title}</h3>

        <div className="how-works-title-line" />

        <ol className="how-works-steps">
          {steps.map((step, index) => (
            <li key={index}>
              <span className="how-works-step-number">{index + 1}</span>
              <span>
                <strong>{step.label}</strong>
                {step.text}
              </span>
            </li>
          ))}
        </ol>
      </div>

      {!reverse && (
        <div className="how-works-visual">
          <div className="how-works-visual-card">
            <i className={visualIcon} />
            <span>{visualText}</span>
          </div>
        </div>
      )}

      {reverse && (
        <div className="how-works-side-rail">
          <i className={sideIcon} />
        </div>
      )}
    </div>
  );
};

const HowItWorksStep = () => {
  return (
    <section className="how-works-area">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="title-area text-center how-works-title-area">
              <span className="how-works-eyebrow">Systems Access</span>

              <h1 className="how-works-main-title">
                How Kiubunifu Systems Work
              </h1>

              <h2 className="how-works-subtitle">
                Sign-Up, Get Involved, Thrive
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="how-works-flow">
          {howItWorksContent.map((item, index) => (
            <HowItWorksStepCard
              key={index}
              title={item.title}
              sideIcon={item.sideIcon}
              visualIcon={item.visualIcon}
              visualText={item.visualText}
              steps={item.steps}
              reverse={item.reverse}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksStep;